var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_71_16",
    "data-name": "Component 71 \\u2013 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.652,
    height: 39,
    viewBox: "0 0 46.652 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_839",
    "data-name": "Rectangle 839",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.652,
    height: 39,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45.652,
    height: 38,
    rx: 4.5,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5608",
    "data-name": "Group 5608",
    transform: "translate(-1520.625 -369.537)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M1552.844,378.421a.475.475,0,0,0-.474-.431H1547.4l-.385-1.6a1.1,1.1,0,0,0-1.076-.847h-3.9a1.112,1.112,0,0,0-1.066.808l-.46,1.643h-4.853a.475.475,0,0,0-.469.4l-.281,1.634a.476.476,0,0,0,.47.557h17.143a.476.476,0,0,0,.475-.52Zm-11.049-1.844a.255.255,0,0,1,.244-.184h3.9a.252.252,0,0,1,.246.194l.337,1.4H1541.4Z",
    fill: "#7b7b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M1535.633,381.548l1.834,18.9a.5.5,0,0,0,.5.454h11.723a.5.5,0,0,0,.5-.453l1.879-18.9a.5.5,0,0,0-.5-.551h-15.436A.5.5,0,0,0,1535.633,381.548Zm4.248,16.678-.048,0a.611.611,0,0,1-.608-.564l-1.094-14.221a.61.61,0,1,1,1.217-.093l1.094,14.22A.609.609,0,0,1,1539.881,398.226Zm4.538-.615a.618.618,0,1,1-1.236,0V383.2a.618.618,0,1,1,1.236,0Zm3.906.056a.609.609,0,0,1-.607.561l-.048,0a.608.608,0,0,1-.559-.654l1.092-14.18a.6.6,0,0,1,.654-.56.61.61,0,0,1,.56.654Z",
    transform: "translate(0.101 0.756)",
    fill: "#7b7b7b"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.5aa4098708b83db94ffa227bb058a8b0.svg";
export { ForwardRef as ReactComponent };